module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mt-5"
  }, [_c('div', {
    staticClass: "alert primary"
  }, [_c('div', {
    staticClass: "alert-text"
  }, [_c('div', {
    staticClass: "font-md"
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("transactionData.transaction")) + ":")]), _vm._v(" " + _vm._s(_vm.txHash) + "\n                                "), _c('Icon', {
    staticClass: "txHash pointer",
    attrs: {
      "type": "ios-copy-outline",
      "title": _vm.$t('common.copy'),
      "data-clipboard-text": _vm.txHash,
      "color": "primary--text"
    },
    on: {
      "click": _vm.copyTxHash
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "font-md"
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("transactionData.contract")) + ":")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transaction.contractAddress != ''),
      expression: "transaction.contractAddress != ''"
    }]
  }, [_vm._v("\n                                    " + _vm._s(_vm.transaction.contractAddress) + "\n                                    "), _c('Icon', {
    staticClass: "contract pointer",
    attrs: {
      "type": "ios-copy-outline",
      "title": _vm.$t('common.copy'),
      "data-clipboard-text": _vm.transaction.contractAddress,
      "color": "primary--text"
    },
    on: {
      "click": _vm.copyContract
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transaction.contractAddress == ''),
      expression: "transaction.contractAddress == ''"
    }]
  }, [_vm._v("\n                                    " + _vm._s(_vm.transaction.to) + "\n                                    "), _c('Icon', {
    staticClass: "contract pointer",
    attrs: {
      "type": "ios-copy-outline",
      "title": _vm.$t('common.copy'),
      "data-clipboard-text": _vm.transaction.to,
      "color": "primary--text"
    },
    on: {
      "click": _vm.copyContract
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowQRCode),
      expression: "isShowQRCode"
    }],
    staticClass: "qrcode",
    attrs: {
      "id": "qrcode"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "200px",
      "height": "200px;"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container mt-4 row"
  }, [_c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.txHash")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.txHash) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.blockHeight")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.transaction.blockNumber) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.time")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.timeStampToTime(_vm.transaction.timeStamp)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.from")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3 primary--text"
  }, [_vm._v("\n                        " + _vm._s(_vm.transaction.from) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.to")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.contract")) + "\n                        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transaction.contractAddress != ''),
      expression: "transaction.contractAddress != ''"
    }],
    staticClass: "primary--text"
  }, [_vm._v("\n                            " + _vm._s(_vm.transaction.contractAddress) + "\n                        ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transaction.contractAddress == ''),
      expression: "transaction.contractAddress == ''"
    }],
    staticClass: "primary--text"
  }, [_vm._v("\n                            " + _vm._s(_vm.transaction.to) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.tokensTransfered")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("transactionData.from")) + " \n                        "), _c('span', {
    staticClass: "primary--text"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n                                    " + _vm._s(_vm.transaction.from > 18 ? _vm.transaction.from.substring(0, 18) + '...' : _vm.transaction.from) + "\n                                ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.transaction.from))])])], 1), _vm._v(" " + _vm._s(_vm.$t("transactionData.to")) + " \n                        "), _c('span', {
    staticClass: "primary--text"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n                                    " + _vm._s(_vm.subToHash(_vm.transaction.input) > 18 ? _vm.subToHash(_vm.transaction.input).substring(0, 18) + '...' : _vm.subToHash(_vm.transaction.input)) + "\n                                ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subToHash(_vm.transaction.input)))])])], 1), _vm._v(" for\n                        " + _vm._s(_vm.getQuantity(_vm.transaction.input)) + " ERC-20(IOB Token)\n                         ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.gasLimit")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.transaction.gas) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.gasUsedByTransaction")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.transaction.gasUsed) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.gasPrice")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.numberToString(_vm.transaction.gasPrice)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.nonceAndPosition")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.transaction.nonce) + "|"), _c('span', [_vm._v("{")]), _vm._v(_vm._s(_vm.transaction.transactionIndex)), _c('span', [_vm._v("}")])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a24a200"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/token/TransactionData.vue
// module id = 417
// module chunks = 0